import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/Hero/Hero'
import About from '../../components/About/About'
import Services from '../../components/Services/Services'
import Gallery from '../../components/Gallery/Gallery'
import WhyUs from '../../components/WhyUs/WhyUs'
import CallToAction from '../../components/CTA/CallToAction'
import Footer from '../../components/Footer/Footer'

const Home = () => {
  return (
    <div>
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Gallery />
        <WhyUs />
        
        <CallToAction />
        <Footer />
    </div>
  )
}

export default Home